module.exports = __webpack_public_path__ + "media/images/fanclub/kv-chara-02@2x-281ce90de4589560fbb4e6d288ba38dc.png";